import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import usePlayerManifest from "../hooks/usePlayerManifest";
import PlayerLayout from "../components/PlayerLayout";
import storage from '../nativeStorage';
import api from '../api';

export default function PlayerDeclareMarker() {
  usePlayerManifest();
  const navigate = useNavigate();
  const token = storage.getItem("player_token");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [event, setEvent] = useState(null);
  const [groupmates, setGroupmates] = useState([]);
  const [busyId, setBusyId] = useState(null);
  const [confirmId, setConfirmId] = useState(null);
  const [toast, setToast] = useState("");

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 3000); };

  useEffect(() => {
    if (!token) { navigate("/player/login"); return; }
    load();
  }, []);

  const load = () => {
    setLoading(true);
    api.get("/player/my-group-today", { headers: { Authorization: "Bearer " + token } })
      .then(res => {
        setEvent(res.data.event);
        setGroupmates(res.data.groupmates || []);
      })
      .catch(err => setError(err.response?.data?.error || "Network error"))
      .finally(() => setLoading(false));
  };

  const declare = async (playerId) => {
    setBusyId(playerId);
    try {
      await api.post("/player/declare-marker",
        { event_id: event.id, marked_player_id: playerId },
        { headers: { Authorization: "Bearer " + token } });
      showToast("Done — you're marking their card!");
      setConfirmId(null);
      load();
    } catch(e) { showToast(e.response?.data?.error || "Failed to declare marker"); }
    finally { setBusyId(null); }
  };

  const btn = { display: "block", width: "100%", padding: "14px", marginBottom: "10px", border: "2px solid #d1d5db", borderRadius: "10px", background: "#f9fafb", textAlign: "left", fontSize: "15px", cursor: "pointer", fontWeight: "600", color: "#111827" };

  const instructions = (
    <>
      <h2 style={{ fontSize: "14px", fontWeight: "700", color: "#14532d", marginBottom: "8px" }}>Tee-box marker declaration</h2>
      <div style={{ fontSize: "12px", color: "#374151", lineHeight: "2.2" }}>
        Agree at the first tee who's marking who — same as real golf. Tap a name here to declare it. During the round you mark that player's card as normal, then verify it afterwards from <strong>Verify a Playing Partner</strong>.
      </div>
    </>
  );

  return (
    <PlayerLayout instructions={instructions}>
      <h1 style={{ fontSize: "20px", fontWeight: "800", color: "#14532d", marginBottom: "4px" }}>🏌️ Who's Marking Today</h1>
      <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "20px" }}>Tee-box marker declaration</p>

      <div style={{ maxWidth: "500px" }}>
        <div style={{ background: "white", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", padding: "20px" }}>
          {loading && <div style={{ textAlign: "center", color: "#6b7280", padding: "30px 0" }}>Loading...</div>}
          {error && <div style={{ background: "#fef2f2", color: "#b91c1c", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "14px" }}>{error}</div>}

          {!loading && !error && !event && (
            <div style={{ color: "#9ca3af", fontSize: "13px", padding: "20px 0", textAlign: "center" }}>
              No active competition found for you today.
            </div>
          )}

          {!loading && event && (
            <>
              <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "8px", padding: "12px 14px", marginBottom: "16px" }}>
                <div style={{ fontWeight: "700", color: "#14532d", fontSize: "14px" }}>{event.venue || "Venue not set"}</div>
                <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                  {event.date ? new Date(event.date).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : ""}
                  {" — "}{event.game_type}
                </div>
              </div>

              <div style={{ fontSize: "14px", fontWeight: "700", color: "#14532d", marginBottom: "4px" }}>Your group</div>
              <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "14px" }}>
                Agreed at the tee who's marking who? Tap a name to declare you're marking their card.
              </div>

              {groupmates.length === 0 && (
                <div style={{ color: "#9ca3af", fontSize: "13px", padding: "16px 0", textAlign: "center" }}>
                  No other players found in your group.
                </div>
              )}

              {groupmates.map(p => {
                const isConfirming = confirmId === p.player_id;
                return (
                  <button key={p.player_id} disabled={busyId === p.player_id} style={btn}
                    onClick={() => p.marker_name && !isConfirming ? setConfirmId(p.player_id) : declare(p.player_id)}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <span>{p.name}</span>
                      <span style={{ fontSize: "11px", color: "#6b7280", fontWeight: "400" }}>
                        {isConfirming ? "Tap again to confirm →"
                          : p.marker_name ? `Currently: ${p.marker_name} — tap to change` : "Tap to mark their card →"}
                      </span>
                    </div>
                  </button>
                );
              })}
            </>
          )}
        </div>
      </div>

      {toast && (
        <div style={{ position: "fixed", bottom: "20px", left: "50%", transform: "translateX(-50%)", background: "#166534", color: "white", padding: "12px 24px", borderRadius: "10px", fontSize: "14px", fontWeight: "600", boxShadow: "0 4px 16px rgba(0,0,0,0.25)", zIndex: 9999 }}>
          {toast}
        </div>
      )}
    </PlayerLayout>
  );
}
